import {
  Card,
  Button,
  useTheme,
  Typography,
  Divider,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { useShopContext } from "../../context/shop/shop.context";

// TODO! :get getShippingMethodWithPrice
interface OrderDetailsProps {
  onClickNext?: () => void;
  nextLabel?: string;
  showShipping?: boolean;
  loading?: boolean;
  disabled?: boolean;
  checkoutStep?: boolean;
  errorMessage?: string;
  waitingMessage?: string;
}
const OrderDetails = ({
  onClickNext,
  showShipping,
  nextLabel,
  loading,
  disabled,
  checkoutStep,
  errorMessage,
  waitingMessage,
}: OrderDetailsProps) => {
  const { shopState, subTotal, shippingMethods } = useShopContext();
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          backgroundColor: (theme) => theme.palette.background.layout,
        }}
        align="center"
      >
        {t("order-details.title")}
      </Typography>
      <Stack my={3}>
        <Typography
          variant="h5"
          sx={{
            mx: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <span>{t("order-details.subtotal")}</span>
          <span>{subTotal.toFixed(2)}€</span>
        </Typography>
        {shopState.shippingMethodId && showShipping && (
          <Typography
            variant="h5"
            sx={{
              mx: 2,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <span>{t(`shipping_methods.${shopState.shippingMethodId}`)}</span>
            <span>
              {shippingMethods.find(
                ({ id }) => id === shopState.shippingMethodId
              )?.price ?? "Gratuit"}
            </span>
          </Typography>
        )}
      </Stack>
      <Divider
        sx={{
          mx: 2,
          borderTopStyle: "solid",
          borderTopColor: (theme) => theme.palette.divider,
        }}
      />
      {/* TODO: compute shipping */}
      <Typography
        variant="h5"
        sx={{
          mx: 2,
          mb: 3,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <span>{t("order-details.total")}</span>
        <span>{subTotal.toFixed(2)}€</span>
      </Typography>

      <Divider
        sx={{
          mx: 2,
          borderTopStyle: "solid",
          borderTopColor: (theme) => theme.palette.divider,
        }}
      />
      {!!loading ? (
        <CircularProgress sx={{ alignSelf: "center", my: 2 }} />
      ) : (
        <Stack
          flexDirection="row"
          justifyContent="space-evenly"
          flexWrap="wrap"
          my={2}
        >
          {!checkoutStep && (
            <Button
              variant="outlined"
              sx={{ m: 1 }}
              onClick={() => router.push("/shop")}
            >
              {t("order-details.continue")}
            </Button>
          )}
          {onClickNext && (
            <Button
              variant="contained"
              sx={{ m: 1 }}
              onClick={onClickNext}
              disabled={disabled}
            >
              {nextLabel ?? t("order-details.next")}
            </Button>
          )}
          {errorMessage && (
            <Typography color="error">{errorMessage}</Typography>
          )}
        </Stack>
      )}
      {waitingMessage && (
        <Typography
          color="primary"
          sx={{
            alignSelf: "center",
            my: 1,
            fontWeight: (theme) => theme.typography.fontWeightMedium,
          }}
        >
          {waitingMessage}
        </Typography>
      )}
      <Divider
        sx={{
          mx: 2,
          borderTopStyle: "solid",
          borderTopColor: (theme) => theme.palette.divider,
        }}
      />

      <Typography variant="body1" align="center" sx={{ mb: 1 }}>
        {t("order-details.footer")}
      </Typography>
    </Card>
  );
};

export default OrderDetails;
